import { NavigationBar } from 'app/views/components/navigation-bar';
import { RightDrawer } from 'app/views/components/right-drawer';
import { Outlet, useMatch } from 'react-router';
import { AppWrapper, ContentWrapper, MainContent } from './Layout.styles';
import { ChangeFacilityDialog } from './components/change-facility-dialog';
import { ProjectBanner } from './components/project-banner/ProjectBanner';
import { useRememberRoute } from './useRememberRoute';
import { MobileNavigationBar } from './components/mobile-navigation-bar';
import { useMobileNavRef } from './useMobileNavPortal';
import { MobileSubnavigationBar } from './components/mobile-subnavigation-bar';
import { EventsDrawer } from 'app/views/alerts/components/events-drawer';
import { TriggerError } from 'app/components/trigger-error/TriggerError';
import { Routing } from 'core/routing/Routing';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v8';

export const LayoutWrapper = () => {
  const { mobileNav, mobileSubnav } = useMobileNavRef();
  const isMonitoringExport = !!useMatch(Routing.routes.monitoring.export);

  useRememberRoute();

  if (isMonitoringExport) {
    return (
      <AppWrapper>
        <NuqsAdapter>
          <Outlet context={{ mobileNav: mobileNav.current, mobileSubnav: mobileSubnav.current }} />
        </NuqsAdapter>
      </AppWrapper>
    );
  }

  return (
    <AppWrapper>
      <ChangeFacilityDialog />
      <TriggerError />
      <MobileNavigationBar ref={mobileNav} />
      <MobileSubnavigationBar ref={mobileSubnav} />
      <NavigationBar />
      <MainContent>
        <ProjectBanner />
        <ContentWrapper>
          <NuqsAdapter>
            <Outlet context={{ mobileNav: mobileNav.current, mobileSubnav: mobileSubnav.current }} />
          </NuqsAdapter>
          <EventsDrawer />
        </ContentWrapper>
      </MainContent>
      <RightDrawer />
    </AppWrapper>
  );
};
